import { useCallback, useState } from 'react';

import get from 'lodash/get';
import type { FileRequest } from '../../../types/FileRequest';
import {
  FILE_REQUEST_STATUS,
  MODE,
  SPOOFED_URL_MESSAGE,
  STATUS_CODE,
} from '../../../constants';
import { useSetTreatmentOverrides } from '../../../common/split-treatment';

export const useFetchSubmissionPageData = () => {
  const setTreatmentOverrides = useSetTreatmentOverrides();
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [fileRequest, setFileRequest] = useState(null);
  const [type, setType] = useState(get(fileRequest, 'type', MODE.FILE_REQUEST));

  const fetch = useCallback(
    async (id: string, api: (idForApi: string) => Promise<FileRequest>) => {
      setIsLoading(true);
      try {
        const response = await api(id);
        const { splitTreatments = {} } = response;

        setIsLoading(false);
        setIsDisabled(response.status !== FILE_REQUEST_STATUS.ACTIVE);
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2345
        setFileRequest(response);
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2345
        setType(response.type);
        setTreatmentOverrides(splitTreatments);
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      } catch (e: any) {
        if (
          e.response.status === STATUS_CODE.BAD_REQUEST &&
          e.response.data?.message === SPOOFED_URL_MESSAGE
        ) {
          setIsLoading(false);
          setRedirectUrl(e.response.data.verifiedURL);
        }

        const shouldHandleError = [
          STATUS_CODE.NOT_FOUND,
          STATUS_CODE.UNAUTHORIZED,
          STATUS_CODE.FORBIDDEN,
        ].includes(e.response.status);

        if (shouldHandleError) {
          // TODO - Should be NOT FOUND page, but setting it to disabled for now
          setIsLoading(false);
          setIsDisabled(true);

          if (e.response.data?.formType) {
            setType(e.response.data.formType);
          }
        }
      }
    },
    [setTreatmentOverrides],
  );

  return { fetch, isLoading, isDisabled, fileRequest, type, redirectUrl };
};
